export default __webpack_public_path__ + "static/media/NATF.729dadd7.png";